module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres6ju"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "receivedStore": _vm.receivedHres6juIndex,
      "searchBoxAlias": "approve",
      "detailEvent": _vm.detailEvent,
      "approveEvent": _vm.approveEvent,
      "approveRowBool": true
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "detail": _vm.detail.tab1,
      "popupTab1": _vm.popupTab1,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang,
      "arrCodtparg": _vm.dropdowns.codtparg,
      "maxRowspanPopupTable1": _vm.maxRowspan.popupDetail,
      "tab1PopupTable1": _vm.columns[_vm.dash.nowLang].tab1PopupTable1,
      "tab1PopupTable2": _vm.columns[_vm.dash.nowLang].tab1PopupTable2,
      "receivedHres6juDetailPopup": _vm.receivedHres6juDetailPopup
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group-button"
  }, [_c('button', {
    ref: "approve",
    staticClass: "btn bg-blue",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hres6ju-popup-approve"
    },
    on: {
      "click": function($event) {
        _vm.callPopupApprove()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" " + _vm._s(_vm.dash.button[_vm.dash.nowLang].approve))])]), _vm._v(" "), _c('popup-approve', {
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "nowLang": _vm.dash.nowLang,
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "arrCodcours": _vm.dropdowns.codcours,
      "arrNumclseq": _vm.dropdowns.numclseq,
      "arrCodplan": _vm.dropdowns.codplan,
      "postHres6juSendApprove": _vm.postHres6juSendApprove,
      "receivedHres6juCourseDetail": _vm.receivedHres6juCourseDetail,
      "indexSelected": _vm.indexSelected,
      "courseDetail": _vm.courseDetail,
      "detailSubmit": _vm.detailSubmit,
      "codappr": _vm.codempid,
      "descCodappr": _vm.dash.currentUser.username[_vm.dash.nowLang],
      "isPopupFirstLoad": _vm.isPopupFirstLoad,
      "setPopupFirstLoad": _vm.setPopupFirstLoad,
      "receivedHres6juNumclseq": _vm.receivedHres6juNumclseq
    }
  }), _vm._v(" "), _c('popup-training', {
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "nowLang": _vm.dash.nowLang,
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "arrCodplan": _vm.dropdowns.codplan,
      "arrCodcours": _vm.dropdowns.codcours,
      "training": _vm.training,
      "codempid": _vm.codempid,
      "popupTrainingTable": _vm.columns[_vm.dash.nowLang].popupTrainingTable,
      "receivedHres6juTraining": _vm.receivedHres6juTraining
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-171e4090!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6ju/component.vue
// module id = 3594
// module chunks = 1